import { createProject } from './create-project.service.ts';
import { deleteProject } from './delete-project.service.ts';
import { getAllProjects } from './get-all-projects.service.ts';
import { getExploreProjects } from './get-explore-projects.service';
import { getProjectAccess } from './get-project-access.service';
import { getProjectDetails } from './get-project-details.service';
import { getProjects } from './get-projects.service';
import { requestProjectAccess } from './request-project-access.service.ts';
import { updateProject } from './update-project.service.ts';

export const projectsService = {
  getProjects,
  deleteProject,
  updateProject,
  createProject,
  getAllProjects,
  getProjectAccess,
  getProjectDetails,
  getExploreProjects,
  requestProjectAccess,
};
